module.exports = __webpack_public_path__ + "static/media/AIYA_LOGO.463d83b7.png";